import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  upgradeBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
    borderRadius: 12,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  upgradeCopy: {
    flex: 1,
    minWidth: 0,
  },
  upgradeTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    color: '#00205B',
    marginBottom: theme.spacing(0.75),
  },
  upgradeCaption: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#172024',
  },
  pillButton: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  ruleActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
    },
  },
  statusGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  editButton: {
    textTransform: 'none',
    fontWeight: 500,
  },
  footerNote: {
    fontSize: '0.75rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    textAlign: 'center',
  },
  approvalTitle: {
    '&&': { paddingBottom: theme.spacing(2) },
  },
  approvalContent: {
    '&&': { paddingTop: 0 },
  },
  dialogHint: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  dialogAlert: {
    marginBottom: theme.spacing(2),
  },
  previewLabel: {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: '#6B7C87',
    marginBottom: theme.spacing(1),
  },
  previewMessage: {
    whiteSpace: 'pre-wrap',
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#172024',
    padding: theme.spacing(1.5, 2),
    backgroundColor: '#F4F6F8',
    borderRadius: 12,
    marginBottom: theme.spacing(2),
  },
  recipients: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
    marginBottom: theme.spacing(2),
  },
  finePrint: {
    fontSize: '0.75rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  finePrintBreak: {
    marginTop: theme.spacing(1),
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  mergeFields: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  mergeFieldsNote: {
    marginTop: theme.spacing(2),
  },
  mergeFieldsLabel: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
  resetButton: {
    marginRight: 'auto',
    textTransform: 'none',
  },
  resultRow: {
    padding: theme.spacing(2, 2.5),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.75, 2),
    },
  },
  resultTitle: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#172024',
  },
  resultDetail: {
    marginTop: theme.spacing(0.5),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  resultEmptyCaption: {
    marginBottom: 0,
  },
  resultFootnote: {
    padding: theme.spacing(1.5, 2.5, 2),
    fontSize: '0.75rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
